import { Component, OnInit } from '@angular/core';
import { MainContainerService } from '../main-container/main-container.service';

@Component({
  standalone: false,
  selector: 'main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.css']
})
export class MainHeaderComponent implements OnInit {

  constructor(
    private mainContainerService: MainContainerService
  ) { }

  ngOnInit() {

  }

}
